// @flow

import * as React from 'react';

import clsx from 'clsx';

import { useTranslator } from '@gandi/translate';
import { Interactive, SrOnly, Svg } from '@gandi/ui';

import styles from './PreferencesButton.scss';

export type Props = {
  className?: string,
  onClick: (SyntheticMouseEvent<HTMLButtonElement>) => void,
};

export default function PreferencesButton({
  className,
  onClick,
}: Props): React.MixedElement {
  const { __ } = useTranslator();
  const label = __('Preferences');
  return (
    <Interactive
      title={label}
      flex
      flexAlignItemsCenter
      flexJustifyCenter
      flexShrink0
      paddingY="none"
      paddingX="xsmall"
      marginX="xsmall"
      hoverBackgroundColor="grey-lighter"
      hoverable
      interactive
      className={clsx(styles.root, className)}
      onClick={onClick}
    >
      <Svg name="cogwheel" theme="anthracite" className={styles.icon} />
      <SrOnly>{label}</SrOnly>
    </Interactive>
  );
}
